import CepInput from './CepInput';

// Bloco de endereço reutilizável: CEP (busca automática) + Logradouro + Número +
// Bairro + Cidade + Estado. `form` deve conter as chaves cep/endereco/numero/
// bairro/cidade/estado; `setForm` é o setState padrão (recebe função updater).
export default function EnderecoFields({ form, setForm }) {
  const preencherComCep = data => setForm(f => ({
    ...f,
    endereco: data.logradouro || f.endereco,
    bairro: data.bairro || f.bairro,
    cidade: data.localidade || f.cidade,
    estado: data.uf || f.estado,
  }));

  return (
    <div className="space-y-4">
      <CepInput value={form.cep} onChange={cep => setForm(f => ({ ...f, cep }))} onEncontrado={preencherComCep} />
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Endereço (Rua/Logradouro)</label>
        <input type="text" placeholder="Rua, Avenida..."
          className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={form.endereco} onChange={e => setForm(f => ({ ...f, endereco: e.target.value }))} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Número</label>
          <input type="text" placeholder="123"
            className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={form.numero} onChange={e => setForm(f => ({ ...f, numero: e.target.value }))} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
          <input type="text"
            className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={form.bairro} onChange={e => setForm(f => ({ ...f, bairro: e.target.value }))} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
          <input type="text"
            className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={form.cidade} onChange={e => setForm(f => ({ ...f, cidade: e.target.value }))} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
          <input type="text" placeholder="UF" maxLength={2}
            className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase"
            value={form.estado} onChange={e => setForm(f => ({ ...f, estado: e.target.value.toUpperCase() }))} />
        </div>
      </div>
    </div>
  );
}
